import { createContext, useContext } from "react";
import type { Layout, Tree } from "./layout-utils";

export type LayoutOption = {
  id: string;
  name: string;
};

type LayoutListContextType = {
  options: LayoutOption[];
  addLayout: (name: string) => string;
  updateLayoutName: (id: string, name: string) => void;
  updateLayoutTree: (id: string, tree: Tree) => void;
  deleteLayout: (id: string) => void;
  selectedLayout: Layout;
  setSelectedLayoutId: (id: string) => void;
};

export const LayoutListContext = createContext<
  LayoutListContextType | undefined
>(undefined);

export const useLayouts = () => {
  const context = useContext(LayoutListContext);
  if (context === undefined) {
    throw new Error("useLayouts must be used within a LayoutListProvider");
  }
  return context;
};
